import { store } from 'store/configureStore';
import { resetState, resetToken } from 'store/oauth/actions';
import { resetState as resetUsuario } from 'store/usuarios/actions';

/**
 *
 * @param url
 * @returns {number} 1 = token ok OR token/login request | 3 = token needs to renew | 0 = expired token
 */
export function checkValidToken(url: string): number {
  if (url.indexOf('token') >= 0 || url.indexOf('login') >= 0) {
    // Se está solicitando el token o haciendo login en la app. Token no necesario
    return 1;
  }
  const state: any = store.getState();
  const token: any = state.oauth.token;
  const apiTokenValidTime: number = token.expires_in * 1000;
  const whenExpires: number = (token.consented_on + token.expires_in) * 1000;
  const now: number = new Date().getTime();
  const remainingTokenTime: number = whenExpires - now;
  const differencePercentage: number = remainingTokenTime / apiTokenValidTime;
  const percentageToRenew: number = 0.35; // Variable para establecer el porcentaje de tiempo restante en el cual se deberá renovar el token
  if (whenExpires > now) {
    // Token valido y dentro de tiempo
    if (differencePercentage <= percentageToRenew) {
      // El token debe renovarse
      return 3;
    }
    return 1;
  }
  return 0;
}

/**
 * @description function that delete the token in the storage and localstorage and redirect to login.
 */
export function logOut() {
  // Reseteamos lo guardado al hacer logout
  store.dispatch(resetToken());
  store.dispatch(resetUsuario());
  store.dispatch(resetState());
  sessionStorage.clear();
  localStorage.clear();
}
